import React, { useState, useEffect } from "react";
import { TextField, IconButton, InputAdornment } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AddBox } from "@mui/icons-material";
import EquipmentSelectionPopup from "../../Popup/EquipmentSelectionPopup";

import { getAreaList, getEqGetMainListByAreaID, getEqGetSubListById } from "../../../store/actions/EquipmentAction";
import { useDispatch, useSelector } from "react-redux";

const ss = sessionStorage;

export default function Machine(props) {
    const dispatch = useDispatch();
    const { t } = useTranslation("translation");

    const [areaData, setAreaData] = useState([]);
    const [areaDataLoaded, setAreaDataLoaded] = useState(false);
    const [mainEquipmentData, setMainEquipmentData] = useState([]);
    const [subEquipmentData, setSubEquipmentData] = useState([]);

    const { equipment } = useSelector((state) => state);

    useEffect(() => {
        if (equipment?.areas?.resultObject) {
            setAreaData(Object.values(equipment.areas.resultObject));
            if (selectedAreaCode != null) {
                dispatch(getEqGetMainListByAreaID(selectedAreaCode));
            }
            setAreaDataLoaded(true);
            equipment.areas.resultObject = null;
        }
        if (equipment?.equipmentListByArea?.resultObject) {
            setMainEquipmentData(equipment.equipmentListByArea.resultObject);
            if (selectedMainEquipmentCode != null) {
                dispatch(getEqGetSubListById(selectedMainEquipmentCode));
            }
            equipment.equipmentListByArea.resultObject = null;
        }
        if (equipment?.eqSubList?.resultObject) {
            setSubEquipmentData(equipment.eqSubList.resultObject);
            equipment.eqSubList.resultObject = null;
        }
    }, [equipment]);

    // Sync internal state from props when parent updates machineStates (e.g., from QR code scan)
    useEffect(() => {
        setSelectedAreaCode(props.machineStates.selectedAreaCode);
        setSelectedAreaName(props.machineStates.selectedAreaName);
    }, [props.machineStates.selectedAreaCode, props.machineStates.selectedAreaName]);

    useEffect(() => {
        setSelectedMainEquipmentCode(props.machineStates.selectedMainEquipmentCode);
        setSelectedMainEquipmentName(props.machineStates.selectedMainEquipmentName);
        setSelectedMainEquipmentNameProp(props.machineStates.selectedMainEquipmentName);
    }, [props.machineStates.selectedMainEquipmentCode, props.machineStates.selectedMainEquipmentName]);

    useEffect(() => {
        setSelectedSubEquipmentCode(props.machineStates.selectedSubEquipmentCode);
        setSelectedSubEquipmentName(props.machineStates.selectedSubEquipmentName);
        setSelectedSubEquipmentNameProp(props.machineStates.selectedSubEquipmentName);
    }, [props.machineStates.selectedSubEquipmentCode, props.machineStates.selectedSubEquipmentName]);

    // Machine popup
    const [machineOpen, setMachineOpen] = useState(false);
    const HandleMachineOpen = () => {
        dispatch(getAreaList());
        setMachineOpen(true);
    };

    const ssAbr = props.machineStates.ssAbr;

    const HandleMachineCancel = () => {
        setMainEquipmentData([]);
        setSubEquipmentData([]);
        setSelectedAreaCode(null);
        setSelectedAreaName(null);
        setSelectedMainEquipmentCode(null);
        setSelectedMainEquipmentName(null);
        setSelectedMainEquipmentNameProp(null);
        setSelectedSubEquipmentCode(null);
        setSelectedSubEquipmentName(null);
        setSelectedSubEquipmentNameProp(null);

        ss.removeItem(ssAbr + "_selectedAreaCode");
        ss.removeItem(ssAbr + "_selectedAreaName");
        ss.removeItem(ssAbr + "_selectedMainEquipmentCode");
        ss.removeItem(ssAbr + "_selectedMainEquipmentName");
        ss.removeItem(ssAbr + "_selectedSubEquipmentCode");
        ss.removeItem(ssAbr + "_selectedSubEquipmentName");

        const newMachineStates = {
            ssAbr: ssAbr,
            selectedAreaCode: null,
            selectedAreaName: null,
            selectedMainEquipmentCode: null,
            selectedMainEquipmentName: null,
            selectedSubEquipmentCode: null,
            selectedSubEquipmentName: null,
        };
        props.setMachineStates(newMachineStates);

        setMachineOpen(false);
    };

    const HandleMachineConfirm = () => {
        const newMachineStates = {
            ssAbr: ssAbr,
            selectedAreaCode: selectedAreaCode,
            selectedAreaName: selectedAreaName,
            selectedMainEquipmentCode: selectedMainEquipmentCode,
            selectedMainEquipmentName: selectedMainEquipmentName,
            selectedSubEquipmentCode: selectedSubEquipmentCode,
            selectedSubEquipmentName: selectedSubEquipmentName,
        };

        if (selectedAreaCode != null) {
            ss.setItem(ssAbr + "_selectedAreaCode", selectedAreaCode);
            ss.setItem(ssAbr + "_selectedAreaName", selectedAreaName);
        }
        if (selectedMainEquipmentCode != null) {
            ss.setItem(ssAbr + "_selectedMainEquipmentCode", selectedMainEquipmentCode);
            ss.setItem(ssAbr + "_selectedMainEquipmentName", selectedMainEquipmentName);
        }
        if (selectedSubEquipmentCode != null) {
            ss.setItem(ssAbr + "_selectedSubEquipmentCode", selectedSubEquipmentCode);
            ss.setItem(ssAbr + "_selectedSubEquipmentName", selectedSubEquipmentName);
        }

        props.setMachineStates(newMachineStates);
        setMachineOpen(false);

        setMainEquipmentData([]);
        setSubEquipmentData([]);
        setSelectedMainEquipmentNameProp(null);
        setSelectedSubEquipmentNameProp(null);
    };

    const [selectedAreaCode, setSelectedAreaCode] = useState(props.machineStates.selectedAreaCode);
    const [selectedAreaName, setSelectedAreaName] = useState(props.machineStates.selectedAreaName);
    const HandleAreaChange = (areaName) => {
        if (areaName != null) {
            const filteredArea = areaData.filter((item) => item.name === areaName);
            setSelectedAreaCode(filteredArea[0].id);
            setSelectedAreaName(filteredArea[0].name);
            dispatch(getEqGetMainListByAreaID(filteredArea[0].id));
            setSubEquipmentData([]);
            setMainEquipmentData([]);
            setSelectedMainEquipmentName(null);
            setSelectedMainEquipmentCode(null);
            setSelectedMainEquipmentNameProp(null);
            setSelectedSubEquipmentName(null);
            setSelectedSubEquipmentNameProp(null);
            setSelectedSubEquipmentCode(null);
            return filteredArea[0].id;
        }
        setMainEquipmentData([]);
        setSubEquipmentData([]);
        setSelectedAreaCode(null);
        setSelectedAreaName(null);
        setSelectedMainEquipmentName(null);
        setSelectedMainEquipmentNameProp(null);
        setSelectedMainEquipmentCode(null);
        setSelectedSubEquipmentName(null);
        setSelectedSubEquipmentNameProp(null);
        setSelectedSubEquipmentCode(null);
    };

    const [selectedMainEquipmentCode, setSelectedMainEquipmentCode] = useState(props.machineStates.selectedMainEquipmentCode);
    const [selectedMainEquipmentName, setSelectedMainEquipmentName] = useState(props.machineStates.selectedMainEquipmentName);
    const [selectedMainEquipmentNameProp, setSelectedMainEquipmentNameProp] = useState(props.machineStates.selectedMainEquipmentName);
    const HandleMainEquipmentChange = (mainEquipmentName) => {
        if (mainEquipmentName != null) {
            const filteredEquipment = mainEquipmentData.filter((item) => item.name === mainEquipmentName);
            setSelectedMainEquipmentCode(filteredEquipment[0].id);
            dispatch(getEqGetSubListById(filteredEquipment[0].id));
            setSelectedMainEquipmentName(filteredEquipment[0].name);
            setSelectedMainEquipmentNameProp(filteredEquipment[0].name);
            setSelectedSubEquipmentName(null);
            setSelectedSubEquipmentNameProp(null);
            setSelectedSubEquipmentCode(null);
            setSubEquipmentData([]);
            return filteredEquipment[0].id;
        }
        setSubEquipmentData([]);
        setSelectedMainEquipmentCode(null);
        setSelectedMainEquipmentName(null);
        setSelectedMainEquipmentNameProp(null);
        setSelectedSubEquipmentName(null);
        setSelectedSubEquipmentNameProp(null);
        setSelectedSubEquipmentCode(null);
    };

    const [selectedSubEquipmentCode, setSelectedSubEquipmentCode] = useState(props.machineStates.selectedSubEquipmentCode);
    const [selectedSubEquipmentName, setSelectedSubEquipmentName] = useState(props.machineStates.selectedSubEquipmentName);
    const [selectedSubEquipmentNameProp, setSelectedSubEquipmentNameProp] = useState(props.machineStates.selectedSubEquipmentName);
    const HandleSubEquipmentChange = (subEquipmentName) => {
        if (subEquipmentName != null) {
            const filteredSubEquipment = subEquipmentData.filter((item) => item.name === subEquipmentName);
            setSelectedSubEquipmentCode(filteredSubEquipment[0].id);
            setSelectedSubEquipmentName(filteredSubEquipment[0].name);
            setSelectedSubEquipmentNameProp(filteredSubEquipment[0].name);
            return filteredSubEquipment[0].id;
        }
        setSelectedSubEquipmentCode(null);
        setSelectedSubEquipmentName(null);
        setSelectedSubEquipmentNameProp(null);
    };

    // Validation
    const [isError, setIsError] = useState(false);
    const [errorText, setErrorText] = useState("");

    useEffect(() => {
        if (!props.error) return;
        if (props.machineStates.selectedMainEquipmentCode || props.machineStates.selectedSubEquipmentCode) {
            props.setError({ ...props.error, machineText: "" });
            setIsError(false);
            setErrorText("");
        } else {
            props.setError({ ...props.error, machineText: t("SelectAMachine") });
            setIsError(true);
            setErrorText(t("SelectAMachine"));
        }
    }, [props.machineStates]);

    return (
        <div>
            <TextField
                id="bl_table_TextField_11"
                label={t("Machine")}
                variant="outlined"
                size={props.size ?? "normal"}
                margin="normal"
                fullWidth
                value={selectedSubEquipmentName ?? selectedMainEquipmentName ?? selectedAreaName ?? ""}
                InputLabelProps={{
                    shrink: true,
                }}
                InputProps={{
                    readOnly: true,
                    endAdornment: (
                        <InputAdornment position="end">
                            {
                                <IconButton id="bl_table_IconButton_1" onClick={() => HandleMachineOpen()}>
                                    <AddBox id="bl_table_AddBox" color="primary" />
                                </IconButton>
                            }
                        </InputAdornment>
                    ),
                }}
                error={isError}
                helperText={errorText}
            />

            <EquipmentSelectionPopup
                selectedAreaName={selectedAreaName}
                selectedMainEquipmentName={selectedMainEquipmentNameProp}
                selectedSubEquipmentName={selectedSubEquipmentNameProp}
                areaDataLoaded={areaDataLoaded}
                machineOpen={machineOpen}
                handleMachineClose={HandleMachineConfirm}
                handleMachineCancel={HandleMachineCancel}
                selectedAreaCode={selectedAreaCode}
                handleAreaChange={HandleAreaChange}
                areaData={areaData}
                selectedMainEquipmentCode={selectedMainEquipmentCode}
                handleMainEquipmentChange={HandleMainEquipmentChange}
                mainEquipmentData={mainEquipmentData}
                selectedSubEquipmentCode={selectedSubEquipmentCode}
                handleSubEquipmentChange={HandleSubEquipmentChange}
                subEquipmentData={subEquipmentData}
                isAreaNotFiltered={props.isAreaNotFiltered}
            />
        </div>
    );
}
